import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "block m-t-b" }
const _hoisted_3 = ["name", "id", "required", "autocomplete", "type", "readonly", "aria-label", "aria-describedby", "aria-invalid", "value", "pattern"]
const _hoisted_4 = {
  key: 0,
  class: "compl",
  "aria-hidden": "true"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { key: 0 }

import { computed, toRef } from 'vue';
import { useField } from 'vee-validate';
import { modes } from '@/validation/interactionModes';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
  type: {
    type: String,
    default: "text",
  },
  defaultValue: {
    type: String,
    default: "",
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  arialabel: {
    type: String,
    required: false,
  },
  label: {
    type: String,
    required: true,
  },
  autocomplete: {
    type: String,
    required: false,
  },
  mode: {
    type: String,
    default: 'aggressive',
  },
  required: { 
    type: Boolean,
    default: false
  },
  helper: {
    type: String,
    default: "",
    required: false,
  },
  requiredPattern: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const { meta, value, errorMessage, handleChange, handleBlur } = useField(
  toRef(props, 'name'),
  null,
  {
    validateOnValueUpdate: false,
  }
);

// Workaround för att sätta defaultvärde på inputfältet.
value.value = props.defaultValue;

// generates the listeners
const handlers = computed(() => {
  const on = {
    blur: handleBlur,
    // default input event to sync the value
    // the `false` here prevents validation
    input: [(e) => handleChange(e, false)],
  };

  // Get list of validation events based on the current mode
  const triggers = modes[props.mode]({
    errorMessage,
    meta,
  });

  // add them to the "on" handlers object
  triggers.forEach((t) => {
    if (Array.isArray(on[t])) {
      on[t].push(handleChange);
    } else {
      on[t] = handleChange;
    }
  });

  return on;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "text-white",
    for: __props.id
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
    _createElementVNode("input", _mergeProps({
      class: ["form-input", { 'error': !!_unref(errorMessage)}],
      name: __props.name,
      id: __props.id,
      required: __props.required,
      autocomplete: __props.autocomplete,
      type: __props.type,
      readonly: __props.readonly,
      "aria-label": __props.arialabel,
      "aria-describedby": 'texterror' + __props.id,
      "aria-invalid": !!_unref(errorMessage)
    }, _toHandlers(handlers.value, true), {
      value: _unref(value),
      pattern: props.requiredPattern
    }), null, 16, _hoisted_3),
    (__props.helper !='')
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      id: 'texterror' + __props.id,
      class: "error-txt"
    }, [
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_5)
  ], 8, _hoisted_1))
}
}

})